import React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';
// import { StripeProvider } from 'react-stripe-elements';
import * as Sentry from '@sentry/browser';
import { Provider } from 'react-redux';
import Routes from '~/components/routes/routes';
import { initializeAuth } from './firebase';
import { actions as authActions } from './redux/auth';
import configureStore from './configureStore';
import config from './config/config.json';
import 'react-big-calendar/lib/css/react-big-calendar.css?global';
import 'react-day-picker/lib/style.css?global';
import './vendor/css/bootstrap.css?global';
import './vendor/css/shards.css?global';
import 'tachyons/css/tachyons.css?global';
import './index.css?global';

Sentry.init({ dsn: config.sentry.dsn });

const rootEl = document.getElementById('root');
const store = configureStore();

const render = () => {
  ReactDOM.render(
    <AppContainer>
      {/* <StripeProvider apiKey={config.stripe.publicKey}> */}
      <Provider store={store}>
        <Routes />
      </Provider>
      {/* </StripeProvider> */}
    </AppContainer>,
    rootEl
  );
};

if (module.hot) {
  module.hot.accept('./components/routes/routes', () => {
    const NextRoutes = require('./components/routes/routes').default; // eslint-disable-line global-require
    ReactDOM.render(
      <AppContainer>
        <Provider store={store}>
          <NextRoutes />
        </Provider>
      </AppContainer>,
      rootEl
    );
  });
}

initializeAuth()
  .then(user => store.dispatch(authActions.authInitialized(user)))
  .then(() => {
    render();
  })
  .catch(error => {
    console.error('Error while initializing Firebase Auth');
    console.error(error);
  });



// WEBPACK FOOTER //
// ./src/entry.jsx